export default __webpack_public_path__ + "static/media/zhuoyu.425bdbe3.jpeg";